<template>
	<div>
		<div id="main" style="text-align: center;">
			{{innertext}}
		</div>
		<!--<el-progress type="circle" :percentage="there"></el-progress>-->
		<!--<el-input-number v-model="num1" @change="handleChange" :min="0" :max="100" label="描述文字"></el-input-number>-->
		
	</div>
		

</template>

<script>
	export default {
		data(){
			return{
				token:"",
				there:0,
				num1:"",
				innertext:'',
				Limits:[]
			}
		},
		methods:{
			handleChange(value){
//				console.log(value)
				this.there = value
			},
			
		},
		created(){
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			if(this.Limits.length == 0){
				this.innertext = '请等待管理员审核'
			}else {
				this.innertext = '欢迎登录！'
			}
			this.token = sessionStorage.getItem("BBRtoken");
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Main.vue?0575034f